import React, { useContext, useState } from 'react';
import { useLingui } from '@lingui/react';
import { Container } from 'src/components/ui';
import AppContext from '../../context/AppContext';
import { AuthContext } from '../../context/AuthContext';
import NavMenu from '../NavMenu';
import Sidebar, { SidebarTabs } from '../Sidebar';

import { ErrorBoundaryWithRouter as ErrorBoundary } from '../ErrorBoundary';
import ErrorFallback from '../ErrorFallback';
import PopupNotification from '../PopupNotification';

function InternalLayout({
  children,
  tabs,
  activeTab,
  setActiveTab,
}: {
  children: React.ReactNode;
  tabs?: SidebarTabs;
  activeTab?: string;
  setActiveTab?: (tab: string) => void;
}) {
  const auth = useContext(AuthContext);
  const { user } = auth;
  const { sidebarExpanded } = useContext(AppContext);
  const versionTag = (window as { APP_VERSION?: string }).APP_VERSION;
  const { i18n: { _locale: locale } = {} } = (useLingui() ?? {}) as any;

  const [isCollapsed, setIsCollapsed] = useState(() => {
    return localStorage.getItem('internal-layout-sidebar') === 'closed';
  });

  function toggleSidebar() {
    const newValue = isCollapsed ? 'open' : 'closed';
    setIsCollapsed(newValue === 'closed');
    localStorage.setItem('internal-layout-sidebar', newValue);
  }

  return (
    <div lang={locale} className={`app-layout ${sidebarExpanded ? 'has-sidebar-tab-open' : ''}`}>
      {user ? (
        <Sidebar
          auth={auth}
          user={user}
          isCollapsed={isCollapsed}
          toggleSidebar={toggleSidebar}
          tabs={tabs}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
      ) : null}
      <Container className="mui-main-content" fluid>
        <NavMenu isCollapsed={isCollapsed} toggleSidebar={toggleSidebar} />
        <ErrorBoundary fallback={ErrorFallback}>
          <div className="app-layout-internal">{children}</div>
        </ErrorBoundary>
      </Container>
      <PopupNotification />
      {versionTag ? <div className="version-tag">{versionTag}</div> : null}
    </div>
  );
}

export default InternalLayout;
